import { type JudgeResult } from '../../types';
import { ResultsGrid, type ViewType } from '../shared';

import { JudgeSearchResultCard } from './JudgeSearchResultCard';

export interface JudgeSearchResultsProps {
  results: JudgeResult[];
  viewType?: ViewType;
}

export const JudgeSearchResults = ({
  results,
  viewType = 'grid',
}: JudgeSearchResultsProps) => (
  <ResultsGrid
    results={results}
    viewType={viewType}
    renderCard={(judgeItem) => <JudgeSearchResultCard judgeItem={judgeItem} />}
    getKey={(judgeItem, index) => judgeItem.id || index}
  />
);
